"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
class Widget {
    constructor() {
        this.children = [];
    }
    /**
     * @deprecated Please use the function setElementVisible
     * @param elem
     * @param visible
     * @param retainPlacement
     */
    static setVisible(elem, visible, retainPlacement = false) {
        (0, __1.setElementVisible)(elem, visible, retainPlacement);
    }
    /**
     * @deprecated Please use the function isElementVisible
     * @param elem
     */
    static isVisible(elem) {
        return (0, __1.isElementVisible)(elem);
    }
    /**
     * @deprecated Please consider using classList functions instead
     * @param elem
     * @param styleName
     * @param applicable
     */
    static setStyleName(elem, styleName, applicable) {
        if (applicable) {
            if (elem.className.indexOf(styleName) === -1) {
                elem.className += ` ${styleName}`;
            }
        }
        else {
            elem.className = elem.className.replace(styleName, "");
        }
    }
    getChildCount() {
        return this.children.length;
    }
    insertAt(child, position) {
        this.children.splice(position, 0, child);
        const htmlElement = this.getHTMLElement(child);
        if (htmlElement) {
            this.element.insertBefore(htmlElement, this.element.children[position]);
        }
    }
    add(child, container = this.element, before) {
        if (!child) {
            return;
        }
        this.children.push(child);
        // Check if widget has an element to support widgets that don't (RadioGroupWrapper)
        if (child instanceof Widget) {
            child.parent = this;
        }
        const childElement = this.getHTMLElement(child);
        if (childElement) {
            if (before) {
                container.insertBefore(childElement, before);
            }
            else {
                container.appendChild(childElement);
            }
        }
    }
    /**
     * @deprecated Use clearHTMLChildren() instead. (You might be looking for clearValue(), which is a function of HasValueWidget)
     * Removes all html children for the Widget.
     */
    clear() {
        this.clearHTMLChildren();
    }
    /**
     * Changed name because it was too unprecise.
     * (e.g. Widget a string value, calling .clear() you'd think it would clear the value and not remove all html children.)
     */
    clearHTMLChildren() {
        for (const child of this.children) {
            const htmlElement = this.getHTMLElement(child);
            htmlElement?.remove();
        }
        this.children = [];
    }
    replace(child, replacementFor) {
        if (!replacementFor.parentElement) {
            throw new Error("Element to replace has no parent element");
        }
        this.children.push(child);
        if (child instanceof Widget) {
            child.parent = this;
        }
        const htmlElement = this.getHTMLElement(child);
        if (htmlElement) {
            replacementFor.parentElement.replaceChild(htmlElement, replacementFor);
        }
    }
    remove(arg) {
        if (typeof arg === "number") {
            this.children.splice(arg, 1);
            return;
        }
        const index = this.children.indexOf(arg);
        if (index < 0) {
            return;
        }
        const [removedWidget] = this.children.splice(index, 1);
        const htmlElement = this.getHTMLElement(removedWidget);
        if (htmlElement) {
            htmlElement.remove();
        }
    }
    getChildren() {
        return this.children;
    }
    setVisible(visible, retainPlacement = false) {
        (0, __1.setElementVisible)(this.element, visible, retainPlacement);
    }
    isVisible() {
        return (0, __1.isElementVisible)(this.element);
    }
    removeFromParent() {
        if (this.parent) {
            this.parent.remove(this);
            this.parent = undefined;
            this.element.remove();
        }
    }
    getParent() {
        return this.parent;
    }
    /**
     * Add css classes to element
     * @param {Array.<string>} tokens rest argument of css classes
     */
    addCssClass(...tokens) {
        this.element.classList.add(...tokens);
    }
    /**
     * Removes css classes to element
     * @param {Array.<string>} tokens rest argument of css classes
     */
    removeCssClass(...tokens) {
        this.element.classList.remove(...tokens);
    }
    /**
     * Add css classes to element
     * @param {string} token rest argument of css classes
     * @param {boolean|undefined} [force] boolean value determines if class should be added or removed
     */
    toggleCssClass(token, force) {
        this.element.classList.toggle(token, force);
    }
    /**
     * @deprecated use classList.add instead
     * @param styleName {string} a string representing css classes
     */
    setStyleName(styleName) {
        this.element.className = styleName;
    }
    /**
     * @deprecated use elementClassList instead, it handles all adding a class properly
     * @param styleName {string} a css class name
     */
    addStyleName(styleName) {
        this.element.className += " " + styleName;
    }
    /**
     * @deprecated Please remove classList.remove instead, this is a faulty implemantion since it didn't
     * initially use replace with \g
     * @param styleName {string} the class to be removed
     */
    removeStyleName(styleName) {
        this.element.className = this.element.className.replace(styleName, "");
    }
    /**
     * Check whether the element is attached to the dom
     * @param element {Element} the element to check
     */
    isAttached(element) {
        if (element) {
            return element.ownerDocument?.body.contains(element) ?? false;
        }
        return false;
    }
    getCssStyle() {
        return this.element.style;
    }
    addClickHandler(handler) {
        this.element.addEventListener("click", handler.bind(this));
    }
    addMouseDownHandler(handler) {
        this.element.addEventListener("mousedown", handler.bind(this));
    }
    addMouseUpHandler(handler) {
        this.element.addEventListener("mouseup", handler.bind(this));
    }
    addMouseMoveHandler(handler) {
        this.element.addEventListener("mousemove", handler.bind(this));
    }
    addOnBlurHandler(handler) {
        this.element.addEventListener("blur", handler.bind(this));
    }
    addOnFocusHandler(handler) {
        this.element.addEventListener("focus", handler.bind(this));
    }
    focus() {
        this.element.focus();
    }
    getHTMLElement(child) {
        if (child instanceof HTMLElement) {
            return child;
        }
        else {
            return child?.element;
        }
    }
}
exports.default = Widget;
//# sourceMappingURL=Widget.js.map